import { styled } from "styled-components";

const TestimonialWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 18px 22px;
  gap: 12px;
  width: 100%;
  background: ${({ theme }) => theme.colors.lightBlue};
  border-radius: 10px;
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.25);
`;

const TestimonialContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 18px;
  width: 100%;

  @media (max-width: 767px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const Avatar = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.primary};
  box-shadow: 0px 6px 14px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (max-width: 767px) {
    width: 48px;
    height: 48px;
  }
`;

const TestimonialText = styled.div`
  font-family: "Sofia Pro", sans-serif;
  font-weight: 600;
  font-size: 18px;
  line-height: 26px;
  color: ${({ theme }) => theme.colors.primary};
  flex: 1;

  strong {
    font-weight: 700;
  }

  @media (max-width: 767px) {
    font-size: 15px;
    line-height: 22px;
  }
`;

const MoreLink = styled.a`
  color: ${({ theme }) => theme.colors.primary};
  text-decoration: underline;
  cursor: pointer;
  font-weight: 700;

  &:hover {
    opacity: 0.8;
  }
`;

interface TestimonialProps {
  avatarUrl?: string;
  authorName?: string;
  text: string;
  moreLink?: string;
}

const Testimonial = ({ avatarUrl, authorName, text, moreLink }: TestimonialProps) => {
  return (
    <TestimonialWrapper>
      <TestimonialContent>
        <Avatar>
          {avatarUrl && (
            <img src={avatarUrl} alt={authorName ? `Fotka uživatele ${authorName}` : "Avatar uživatele"} />
          )}
        </Avatar>
        <TestimonialText>
          <strong>Testimonial:</strong> {text}{" "}
          {moreLink && <MoreLink href={moreLink}>Více info...</MoreLink>}
        </TestimonialText>
      </TestimonialContent>
    </TestimonialWrapper>
  );
};

export default Testimonial;
